export default function call(state = {}, action) {
  switch (action.type) {
    case 'SET_CALL':
      return action.payload || {}

    default:
      return state
  }
}
